import React from 'react'

const IdentificationChat = () => {
    return (
        <div className='row mt-3'>
            <div className='h5 mt-2'>Identification</div>
            <div className='text-center d-grid gap-2 pt-3 shadow'>
                <div>Nouveau ?</div>
                <button 
                    className='btn btn-outline-dark mt-2 active rounded-pill' 
                    type='button'
                    data-bs-toggle="modal" 
                    data-bs-target="#createAccountModal"
                >Créer un compte</button>
                <div className='mt-2'>Ou</div>
                <button 
                    className='btn btn-outline-dark mt-2 mb-5 rounded-pill' 
                    type='button'
                    data-bs-toggle="modal" 
                    data-bs-target="#connectModal"
                >Se connecter</button>
            </div>
        </div>
    )
}

export default IdentificationChat